import type {
  ColumnDef,
  OnChangeFn,
  RowSelectionState,
  SortingState,
} from '@tanstack/react-table'

export enum TableListStaticColumnsEnum {
  DETAILS = 'DETAILS',
  ICON = 'ICON',
  SELECTION = 'SELECTION',
}

export interface TableBaseProps<T> {
  columns: ColumnDef<T>[]
  data: T[]
  e2eRowId: string
  className?: string
  isLoading?: boolean
  isSearching?: boolean
  hideArrow?: boolean
  onSortingChange?: OnChangeFn<SortingState>
  sorting?: SortingState
  previewedRowIndex?: string | number | null
  customNoResultsMessage?: string
  withSubrows?: boolean
}

type TableSelectionProps =
  | {
      enableRowSelection: true
      rowSelection: RowSelectionState
      onRowSelectionChange: OnChangeFn<RowSelectionState>
    }
  | {
      enableRowSelection?: false
      rowSelection?: never
      onRowSelectionChange?: never
    }

export type TableProps<T> = TableBaseProps<T> & TableSelectionProps
